angular.module('am4')
.directive('equipmentImage', function(config) {
    return {
        restrict: 'E',
        scope: {
            url: '=',
            transform: '@transform'
        },
        template: '<img>',
        link: function(scope, element) {
            var transform = scope.transform ? 'transformed/' + scope.transform : '',
                placeholder = config.machinePlaceholderImage,
                src = scope.url ? scope.url + transform : placeholder;
            element.find('img')[0].src = src;
        }
    };
});



// WEBPACK FOOTER //
// ./src/app/directives/equipmentImage.js